import styled from "styled-components";
import { V3Caption } from "../../../components/Typography";
import { media } from "../../../theme/theme";

export const V3NameSettingWrapper = styled.div`
    display: flex;
    align-items: top;
    justify-content: space-between;
    flex-wrap: wrap;

    > div {
        width: 100%;

        &:first-child {
            margin-bottom: 20px;
        }

        ${media.custom(1080)} {
            width: calc(50% - 12px);
        }
    }
`;

export const TooltipContactText = styled(V3Caption)`
    max-width: 235px;
    display: block;
    color: white;
`;

export const V3SettingsCTAPanel = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    > div {
        &:nth-child(2) {
            padding-left: 30px;
            flex-shrink: 0;
        }
    }
`;

export const V3SettingsPassEditWrapper = styled.div`
    max-width: 400px;
`;

export const V3SettingsDownloadWrapper = styled.div`
    display: flex;

    > div {
        &:first-child {
            margin-right: 20px;
        }
    }
`;

export const V3SettingsLabelWithTooltip = styled.div`
    display: flex;

    > div {
        &:first-child {
            margin-right: 6px;
        }
    }
`;

export const V3SettingsBrandingOption = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 6px;
`;

export const V3SettingsBrandingRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
`;